import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import CardServiceCategory from 'components/CardServiceCategory';

import { Container, MoreCategory } from './styles';

function Categories() {
  const [showAll, setShowAll] = useState(false);
  const categories = useSelector(state => state.categories.data);

  const categoriesToShow = categories.length > 0 && categories.filter(
    (category, index) => showAll || index < 8,
  );

  return (
    <Container>
      {
        categoriesToShow.length && categoriesToShow.map(({ id, name, image }) => (
          <CardServiceCategory
            key={id}
            idCategory={id}
            nameCategory={name}
            imageCategory={image}
          />
        ))
      }
      {
        !showAll && (
          <MoreCategory primary onClick={() => setShowAll(!showAll)}>
            Veja todas as categorias
          </MoreCategory>
        )}
    </Container>
  );
}

export default Categories;
